import { useState } from "react";
import { accessAPI } from "../../shared";
import { Formulario } from "../../shared";
import { Card } from "primereact/card";
export default function ComunicarReevaluacion(props) {
  const [loader, setLoader] = useState(false);

  const { mostrarMensaje } = props;

  const configComunicarReevaluacion = {
    secciones: [
      {
        nombre: "Comunicar reevaluacion",
        campos: [
          {
            nombre: "nroItemDni",
            tipoitemformularioid: 1,
            etiqueta: "Número de ítem DNI",
            requerido: true
          },
          {
            nombre: "nroAnalisisLatu",
            tipoitemformularioid: 4,
            etiqueta: "Número de análisis",
            requerido: true
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Enviar", callback: comunicarReevaluacion, validar: true }
    ]
  };

  function comunicarReevaluacion(camposFormulario) {
    setLoader(true);
    accessAPI(
      "POST",
      "dni/juguetes/test/comunicarReevaluacion",
      camposFormulario,
      (respuesta) => {
        alert(JSON.stringify(respuesta));
        setLoader(false);
      },
      (respuesta) => {
        mostrarMensaje({
          mensaje: respuesta[0].msg,
          temporal: true,
          error: true
        });
        setLoader(false);
      }
    );
  }

  return (
    <Card>
      <Formulario
        loader={loader}
        config={configComunicarReevaluacion}
        formularioEnCuerpo
      />
    </Card>
  );
}
